export default "__VITE_ASSET__Cvn5CpOk__"